import { h } from "vue";

import { props } from "shared/components/MentionCard";
import SocialMentionCardBlogPost from "shared/components/SocialMentionCardBlogPost.vue";
import SocialMentionCardBlueskyPost from "shared/components/SocialMentionCardBlueskyPost.vue";
import SocialMentionCardFacebookPost from "shared/components/SocialMentionCardFacebookPost.vue";
import SocialMentionCardForumPost from "shared/components/SocialMentionCardForumPost.vue";
import SocialMentionCardInstagramComment from "shared/components/SocialMentionCardInstagramComment.vue";
import SocialMentionCardInstagramPost from "shared/components/SocialMentionCardInstagramPost.vue";
import SocialMentionCardRedditPost from "shared/components/SocialMentionCardRedditPost.vue";
import SocialMentionCardRedditPostComment from "shared/components/SocialMentionCardRedditPostComment.vue";
import SocialMentionCardTweet from "shared/components/SocialMentionCardTweet.vue";
import SocialMentionCardYoutubeVideo from "shared/components/SocialMentionCardYoutubeVideo.vue";
import { constantize } from "shared/helpers/string";

function getCardTypeComponent(context) {
  const { mention } = context;
  const { type } = mention;
  const cardComponent = `SocialMentionCard${constantize(type)}`;

  return {
    SocialMentionCardBlogPost,
    SocialMentionCardBlueskyPost,
    SocialMentionCardFacebookPost,
    SocialMentionCardForumPost,
    SocialMentionCardInstagramComment,
    SocialMentionCardInstagramPost,
    SocialMentionCardRedditPost,
    SocialMentionCardRedditPostComment,
    SocialMentionCardTweet,
    SocialMentionCardYoutubeVideo,
  }[cardComponent];
}

export default {
  name: "SocialMentionCardFactory",
  props,
  render() {
    const contextWithEvents = { ...this.$props, ...this.$attrs };

    return h(getCardTypeComponent(this.$props), contextWithEvents, this.$slots);
  },
};
